import { useState } from "react";
import ChevronRight from "./Icons/ChevronRight";
import { destinations, NavigationProps } from "../navigation";
import styles from "../styles/Explorer.module.css";

/** Lists the shared destinations as files in the desktop explorer. */
export default function Explorer({ active, navigateCallback }: NavigationProps) {
	const [portfolioOpen, setPortfolioOpen] = useState(true);

	return (
		<nav className={styles.explorer} aria-label="Explorer" data-editor-navigation>
			<p className={styles.title}>Explorer</p>
			<button
				type="button"
				className={styles.heading}
				aria-expanded={portfolioOpen}
				aria-controls="portfolio-files"
				onClick={() => setPortfolioOpen(!portfolioOpen)}>
				<ChevronRight
					className={styles.chevron}
					style={portfolioOpen ? { transform: "rotate(90deg)" } : {}}
				/>
				Portfolio
			</button>
			<div id="portfolio-files" className={styles.files} hidden={!portfolioOpen}>
				{destinations.map(({ name, filename, icon }) => (
					<button
						key={name}
						type="button"
						className={styles.file}
						aria-current={active === name ? "page" : undefined}
						onClick={() => navigateCallback(name)}>
						<img src={`/${icon}`} alt="" height={18} width={18} />
						<span>{filename}</span>
					</button>
				))}
			</div>
		</nav>
	);
}
